import React from "react";
import axios from "axios";
import { BACKEND_URL } from "../config/Constant";
import api from "../utils/axiosInstance";
const API = "campaign";

const token = localStorage.getItem("Token");



export const getPhoneNumber = async () => {
    try {
      const response = await api.post(`${BACKEND_URL}/contactlist/numbers`, null);
      return response;
    } catch (error) {
      return error;
    }
  };

  export const createCampaign = async (data) => {
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/addcampaign`, data);
      return response;
    } catch (error) {
      return error;
    }
  };

  export const getCampaign = async (data) => {
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/campaignlist`, null);
      return response;
    } catch (error) {
      return error;
    }
  };

  
  export const getCampaignDetail = async (data) => {
    const id={
      campId:data
    }
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/campaigndetails`, id);
      return response;
    } catch (error) {
      return error;
    }
  };


  
